import { configureStore } from '@reduxjs/toolkit';
import loginReducer from './pages/Login/loginSlice';
import appReducer from './app/appSlice';
import errorReducer from './pages/errorHandler/errorHandlerSlice';
import toastNotificationReducer from './features/toastNotification/toastNotificationSlice';
import changePasswordReducer from './pages/changePassword/changePasswordSlice';
import tenantSummaryReducer from './pages/AccountSettings/AccountSettingsHeader/accountSettingsHeaderSlice';
import orgInfoReducer from './pages/AccountSettings/myOrgInfo/myOrgInfoSlice';
import myFundsReducer from './pages/AccountSettings/myFunds/myFundsSlice';
import orderEntryReducer from './pages/OrderEntryForm/OrderEntrySlice';
import swapsDashboardReducer from './pages/SwapsTek/DashboardSlice';
import userGroupsReducer from './pages/AccountSettings/userGroups/userGroupSlice';
import myAccountsReducer from './pages/AccountSettings/myAccounts/myAccountsSlice';
import swapBasketsReducer from './pages/SwapBaskets/SwapBasketsSlice';
import layoutReducer from './features/layout/layoutSlice';
import myClientsReducer from './pages/AccountSettings/myClients/myClientsSlice';
import orderDetailsReducer from './pages/SwapsTek/OrderDetails/OrderDetailsSlice';
import userListReducer from './pages/AccountSettings/usersList/userListSlice';
import counterpartiesReducer from './pages/AccountSettings/counterparties/counterpartiesSlice';
import gridDataReducer from './common/Grid/GridSlice';
import holidaysReducer from './pages/AccountSettings/myHolidays/myHolidaysSlice';
import amendmentReducer from './pages/SwapsTek/Amendment/AmendmentSlice';
import auditTrailReducer from './pages/SwapsTek/AuditTrail/AuditTrailSlice';

export const store = configureStore({
  reducer: {
    login: loginReducer,
    app: appReducer,
    error: errorReducer,
    toastNotification: toastNotificationReducer,
    changePassword: changePasswordReducer,
    tenantSummary: tenantSummaryReducer,
    orgInfo: orgInfoReducer,
    myFunds: myFundsReducer,
    orderEntry: orderEntryReducer,
    swapBaskets: swapBasketsReducer,
    swapsDashboard: swapsDashboardReducer,
    userGroups: userGroupsReducer,
    myAccounts: myAccountsReducer,
    myClients: myClientsReducer,
    layout: layoutReducer,
    orderDetails: orderDetailsReducer,
    userList: userListReducer,
    counterparties: counterpartiesReducer,
    gridData: gridDataReducer,
    holidaysData: holidaysReducer,
    amendment: amendmentReducer,
    auditTrail: auditTrailReducer,
  },
});

// Types for use throughout the app
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
